import mitt from "mitt";
import type * as THREE from "three";

export type Events = {
  "engine:started": void;
  "engine:stopped": void;
  "weapon:fired": { id: string };
  // Emitted by projectile detonation and hitscan hits; VFX systems subscribe
  "weapon:hit": { point: THREE.Vector3; radius: number; weaponId: string };
  "enemy:fired": { from: THREE.Vector3; to: THREE.Vector3; hit: boolean };
  "squad:waypointReached": { index: number };
  "squad:memberDown": { index: number; name?: string; friendlyFire?: boolean };
  "squad:underFire": { from: THREE.Vector3; to: THREE.Vector3; hit: boolean };
  // Player ordnance landed on or danger-close to Alpha
  "squad:friendlyFire": { hits: number };
  // RESCUE: the moving squad reached the trapped element
  "squad:linkUp": Record<string, never>;
  // Player Stop/Go command state changed
  "squad:commandHold": { holding: boolean };
  // COMBAT MEDIC trait negated a lethal hit
  "squad:deathPrevented": { name: string };
  "squad:completed": void;
  "mission:started": void;
  "mission:ended": { success: boolean };
  "enemy:killed": { wasTopThreat: boolean };
  "orbit:targetChanged": { target: "squad" | "enemy" };
  // Anti-air: ground fire and missiles vs the aircraft
  "flak:burst": { from: THREE.Vector3; to: THREE.Vector3 };
  "flak:missileLaunch": { from: THREE.Vector3 };
  "flak:missileEnded": { defeated: boolean };
  "flak:destroyed": { kind: "aa" | "manpads"; position: THREE.Vector3 };
  "aircraft:hit": { amount: number; source: "aa" | "manpads" };
  // Armor: tanks and infantry-carrying trucks
  "armor:destroyed": { kind: "tank" | "truck"; position: THREE.Vector3 };
  "armor:deployed": { position: THREE.Vector3 };
  "armor:tankFired": { hit: boolean };
  "armor:ricochet": { position: THREE.Vector3 };
  "armor:escaped": { kind: "tank" | "truck"; position: THREE.Vector3 };
  "sensor:modeChanged": { mode: "white-hot" | "black-hot" | "eo-green" | "daylight" };
};

export const bus = mitt<Events>();
